import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {EVENT_TYPES} from '../../../../../../redux/event/event.type';
import {TState} from '../../../../../../redux/store.type';

export function useEventTypesList() {
    const {t: tLayout} = useTranslation('layout');
    const permissions = useSelector((s: TState) => s.account.permissions);

    const eventTypesList = useMemo(() => {
        const arrayTypes = [
            {key: EVENT_TYPES.TICKET, text: tLayout('ticketEvent'), permission: true},
            {key: EVENT_TYPES.AREA, text: tLayout('areaEvent'), permission: 'area'},
            {key: EVENT_TYPES.TIMETABLE, text: tLayout('timetableEvent'), permission: 'timetable'}
        ];

        return arrayTypes.filter(item => {
            if(item.permission === true) return true;
            const permissionObj = permissions?.find(p => p.permission === item.permission);
            const status = permissionObj?.status;
            return status === 1;
        });
    }, [permissions, tLayout]);

    return eventTypesList;
}

